import { Component, Inject, Input, OnInit, OnDestroy } from '@angular/core';
import { StudyNavigationService } from '../../services/study-navigation.service';
import { UtilsService } from '../../services/utils.service';
import { ArchiveDNSResultsService } from '../../services/archive-dns-results.service';
import { ExtractedMediaFile } from '../../services/media-loader.service';
import { Subscription } from 'rxjs';
import { LoadConfigService } from '../../services/load-config.service';
import { InstructionService } from '../../services/instruction.service';

@Component({
  selector: 'app-media-display',
  templateUrl: './media-display.component.html',
  styleUrls: ['./media-display.component.scss'],
})
export class MediaDisplayComponent implements OnInit, OnDestroy {
  isMediaVisible: boolean = true;
  @Input('label') label: string;
  private readingTimeStart: number;
  private media: ExtractedMediaFile = null;
  private mediaSub: Subscription;

  mediaInstruction: {
    pdf: string;
    image: string;
  };

  constructor(
    private instructionService: InstructionService,
    private navigation: StudyNavigationService,
    private utils: UtilsService,
    private archiveService: ArchiveDNSResultsService,
    @Inject('BASE_URL') private baseUrl: string
  ) {}

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this.mediaSub.unsubscribe();
  }

  private init() {
    this.mediaSub = this.navigation.mediaSubject.subscribe((media) => {
      this.media = media;
      // you need to start the time here otherwise the timer would not reset when loading consecutive media files
      this.readingTimeStart = this.utils.getCurrentTime();
    });

    if (!this.label) {
      this.label = this.instructionService.getTranslationsForTerm(
        'MEDIA_CONTINUE_BUTTON'
      );
    }

    this.mediaInstruction = this.instructionService.getTranslationsForTerm(
      'MEDIA_INSTRUCTION'
    );
  }

  handleContinue() {
    this.navigation.renderNext();
  }

  saveReadingTime() {
    const currentTime = this.utils.getCurrentTime();
    const readingTime = currentTime - this.readingTimeStart;
    this.archiveService.saveMediaToResults(this.media, readingTime);

    this.navigation.setNextMedia();
  }

  toggleVisibility() {
    this.isMediaVisible = !this.isMediaVisible;
  }

  getFilePath() {
    const mediaType = this.getMediaType();
    const assetPath = `${this.baseUrl}assets`;

    if (mediaType !== null)
      return `${assetPath}/${mediaType}/${this.getMediaName()}`;
  }

  getMediaType() {
    return this.media?.type;
  }

  private getMediaName() {
    return this.media.name;
  }
}
